<i18n src='../../static/localization/map.json'></i18n>
<template>
  <v-app>
    <v-navigation-drawer
      fixed
      :clipped="clipped"
      v-model="drawer"
      app
    >
      <v-list>
        <v-list-tile @click="" value="true">
          <v-list-tile-action>
            <v-icon class>home</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ $t('layerPanel.home') }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-divider></v-divider>

        <v-list-tile @click="showAnalytics=!showAnalytics; drawerSide=false" value="true">
          <v-list-tile-action>
            <v-icon>ac_unit</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ $t('layerPanel.sensors') }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-divider></v-divider>

        <v-list-tile @click="addRemovePoiFromMap()">
          <v-list-tile-action>
            <v-icon>fa-map-marker</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ $t('layerPanel.poi') }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-divider></v-divider>

      </v-list>
      <v-list two-line>
            <template v-for="(layer, index) in $store.getters.getLayers">
              <v-list-tile
                avatar
                ripple
                @click="toggleModel(layer.properties.id, layersOn); addRemoveGeoJSONToMap(layer.properties.id); showAnalytics=true; getLayerInfo(layer.properties.id); drawerSide=true; map.invalidateSize(true)"
                :key="layer.properties.id">
              <v-list-tile-action>
                <v-checkbox v-model="layersOn" :value="layer.properties.id" @click=""></v-checkbox>
              </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ layer.properties.name }}</v-list-tile-title>
                  <v-list-tile-sub-title class="grey--text text--darken-4">{{ layer.properties.place }}</v-list-tile-sub-title>
                  <v-list-tile-sub-title>
                    <span class="tileCircle">
                      <v-icon v-if="layer.properties.meta.difficulty===1" color="blue">fa-circle</v-icon>
                      <v-icon v-if="layer.properties.meta.difficulty===2" color="red">fa-circle</v-icon>
                      <v-icon v-if="layer.properties.meta.difficulty===3" color="black">fa-circle</v-icon>
                    </span>
                    &nbsp;&nbsp;
                    <span class="tileFlake" v-if="layer.properties.meta.trackSnowState===3">
                    <v-icon color="blue">fa-snowflake-o</v-icon>
                    <v-icon color="blue">fa-snowflake-o</v-icon>
                    <v-icon color="blue">fa-snowflake-o</v-icon>
                  </span>
                  <span class="tileFlake" v-if="layer.properties.meta.trackSnowState===2">
                    <v-icon color="blue">fa-snowflake-o</v-icon>
                    <v-icon color="blue">fa-snowflake-o</v-icon>
                    <v-icon color="grey">fa-snowflake-o</v-icon>
                  </span>
                  <span class="tileFlake" v-if="layer.properties.meta.trackSnowState===1">
                    <v-icon color="blue">fa-snowflake-o</v-icon>
                    <v-icon color="grey">fa-snowflake-o</v-icon>
                    <v-icon color="grey">fa-snowflake-o</v-icon>
                  </span>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-list-tile-action-text>{{ layer.properties.meta.length }} km</v-list-tile-action-text>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider></v-divider>
            </template>
          </v-list>
    </v-navigation-drawer>



    <v-toolbar fixed app :clipped-left="clipped" class="elevation-0, indigo">
      <!-- <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon> -->
      </v-btn>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content>
      <v-container fluid>
        <v-slide-y-transition mode="out-in">
          <v-layout>
            <analytics v-bind:class="{ show: !showAnalytics }"></analytics>
            <div id="map" v-bind:class="{ hide: !showAnalytics }"></div>
            <div id="elevChartdiv" transition="slide-y-reverse-transition" v-bind:class="{ show: drawerSide }"></div>
          </v-layout>
        </v-slide-y-transition>

      </v-container>
      <v-navigation-drawer fixed app right width="400" :clipped="clipped" v-model="drawerSide" class="sidebar">
            <v-toolbar-side-icon @click.stop="drawerSide = !drawerSide"></v-toolbar-side-icon>
              <v-card class="elevation-0">
                <v-card-media src="https://thumbs.dreamstime.com/b/cross-country-ski-path-8252693.jpg" height="200px">
                </v-card-media>
                <v-card-title primary-title>
                  <div>
                    <h3 class="headline mb-0">{{ layerProps.name }}</h3>
                    <h3 class="subheading mb-0">{{ layerProps.place }}</h3>
                  </div>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-actions class="infoCard">
                  <div v-if="layerProps.meta.trackStatus===1" class="skipathState" style="color: #43A546">
                    <v-icon aria-hidden="true" color="green">fa-smile-o</v-icon>
                    <br>
                    <p>{{ $t('sidebar.state.wellMaintained') }}</p>
                  </div>
                  <div v-if="layerProps.meta.trackStatus===0" class="skipathState" style="color: #F33A30">
                    <v-icon aria-hidden="true" color="red">fa-frown-o</v-icon>
                    <br>
                    <p>{{ $t('sidebar.state.notMaintained') }}</p>
                  </div>
                  <div v-if="layerProps.meta.difficulty===1" class="skipathDifficulty" style="color: #4DA4F4">
                    <v-icon aria-hidden="true" color="blue">fa-circle</v-icon>
                    <br>
                    <p>{{ $t('sidebar.state.beginner') }}</p>
                  </div>
                  <div v-if="layerProps.meta.difficulty===2" class="skipathDifficulty" style="color: #ff0000">
                    <v-icon aria-hidden="true" color="red">fa-circle</v-icon>
                    <br>
                    <p>{{ $t('sidebar.state.medium') }}</p>
                  </div>
                  <div v-if="layerProps.meta.difficulty===3" class="skipathDifficulty" style="color: #000000">
                    <v-icon aria-hidden="true" color="black">fa-circle</v-icon>
                    <br>
                    <p>{{ $t('sidebar.state.difficult') }}</p>
                  </div>
                </v-card-actions>
              </v-card>
              <v-divider></v-divider>
              <v-list dense class="pt-0">
              <!-- <div id="elevChartdiv" ></div> -->
              <v-card-text xs4>
                <p class="details body-1"><em>{{ $t('sidebar.length') }}:</em><span class="sidebarValues">{{ layerProps.meta.length }} m </span></p>
                <p class="details body-1"><em>{{ $t('sidebar.trackState') }}:</em><span class="sidebarValues">{{ layerProps.meta.trackStatus }}</span></p>
                <p class="details body-1"><em>{{ $t('sidebar.trackStateNote') }}:</em><span class="sidebarValues">{{ layerProps.meta.trackStateNote }}</span></p>
                <p class="details body-1"><em>{{ $t('sidebar.trackSnowState') }}:</em>
                  <span class="sidebarValues" v-if="layerProps.meta.trackSnowState===3">
                    <v-icon color="blue">fa-snowflake-o</v-icon>
                    <v-icon color="blue">fa-snowflake-o</v-icon>
                    <v-icon color="blue">fa-snowflake-o</v-icon>
                  </span>
                  <span class="sidebarValues" v-if="layerProps.meta.trackSnowState===2">
                    <v-icon color="blue">fa-snowflake-o</v-icon>
                    <v-icon color="blue">fa-snowflake-o</v-icon>
                    <v-icon color="grey">fa-snowflake-o</v-icon>
                  </span>
                  <span class="sidebarValues" v-if="layerProps.meta.trackSnowState===1">
                    <v-icon color="blue">fa-snowflake-o</v-icon>
                    <v-icon color="grey">fa-snowflake-o</v-icon>
                    <v-icon color="grey">fa-snowflake-o</v-icon>
                  </span>
                  <span class="sidebarValues" v-if="layerProps.meta.trackSnowState===0">
                    <v-icon color="grey">fa-snowflake-o</v-icon>
                    <v-icon color="grey">fa-snowflake-o</v-icon>
                    <v-icon color="grey">fa-snowflake-o</v-icon>
                  </span>
                </p>
                <p class="details body-1"><em>{{ $t('sidebar.difficulty') }}:</em><span class="sidebarValues">{{ layerProps.meta.difficulty }}</span></p>
                <p v-if="layerProps.meta.note" class="details body-1"><em>{{ $t('sidebar.note') }}:</em><span class="sidebarValues">{{ layerProps.meta.note }}</span></p>
              </v-card-text>
              </v-list>
            </v-navigation-drawer>
    </v-content>
  </v-app>

</template>
<script>
import 'amcharts3'
import 'amcharts3/amcharts/serial'
import { HTTP } from '../common/http'
import { placeholders } from '../../static/localization/placeholders'
import L from 'leaflet'
import 'leaflet.gridlayer.googlemutant'
import analytics from './Analytics'
import { mapState, mapMutations } from 'vuex'
import $ from 'jquery'
// BASEMAPS
const baseMaps = {
  'Google Roads': L.gridLayer.googleMutant({ type: 'roadmap' }),
  'Google Satellite': L.gridLayer.googleMutant({ type: 'satellite' }),
  'Google Terrain': L.gridLayer.googleMutant({ type: 'terrain' }),
  'Google Hybrid': L.gridLayer.googleMutant({ type: 'hybrid' })
}

export default {
  name: 'map',
  components: {
    analytics
  },
  data () {
    return {
      isActive: true,
      showAnalytics: true,
      layersOn: [], // list of all switched on layers id
      layerProps: {
        name: '',
        meta: {
          trackStatus: '',
          length: '',
          difficulty: '',
          elevation: '',
          trackSnowState: '',
          trackStateNote: '',
          note: ''
        }
      },
      sensorsOn: [],
      sensors: [], // list of sensors
      layerComposition: new L.layerGroup(),
      map: {},
      poi: null,
      clipped: true,
      drawer: true,
      drawerSide: false,
      fixed: false,
      right: true,
      rightDrawer: false,
      layers: this.$store.getters.getLayers,
      leafletEvelChart: null
    }
  },
  mounted () {
    this.$i18n.locale = 'sk'
    const map = L.map('map', {
      center: [48.738353, 18.988528],
      zoom: 13,
      layers: [baseMaps['Google Hybrid']],
      zoomControl: false
    })
    L.control.scale({
      metric: true,
      imperial: false,
      position: 'bottomright'
    }).addTo(map)
    L.control.zoom({ position: 'bottomright' }).addTo(map)
    L.control.layers(baseMaps, null, { collapsed: true }).addTo(map)
    this.layerComposition.addTo(map)
    this.map = map
    this.getSkipaths()
  },
  computed: {
    ...mapState({
    })
  },
  watch: {
    drawer: function () {
      this.map.invalidateSize()
    }
  },
  methods: {
    ...mapMutations([
      'loadLayers',
      'loadSensors'
    ]),
    getSkipaths: function () {
      return new Promise((resolve) => {
        HTTP.get('/skipaths')
          // .then(response => {
          //   console.log(response.data.data.filter(data => data.properties.category==='skipath'))
          // })
          .then(response => {
            this.$store.commit('loadLayers', response.data.data.filter(data => data.properties.category==='skipath'))
            this.$store.commit('loadPoi', response.data.data.filter(data => data.properties.category==='poi'))
            this.poi = L.geoJSON({
              'type': 'FeatureCollection',
              'features': this.$store.getters.getPoi
            }, {
              pointToLayer: (feature, latlng) => {
                return L.marker(latlng)
              },
              onEachFeature: (feature, layer) => {
                layer.bindPopup(feature.properties.name)
                layer.on('mouseover', () => layer.openPopup())
                layer.on('mouseout', () => layer.closePopup())
              }
            })
          })
          .catch(error => console.log(error))
      })
    },
    addRemoveGeoJSONToMap: function (id) {
      const layers = this.$store.getters.getLayers.filter(layer => layer.properties.id === id)
      const skipath = L.geoJSON(layers, {
        // onEachFeature: this.getLayerInfo
      })
      skipath.id = id
      if (this.layersOn.includes(id)) {
        skipath.addTo(this.layerComposition)
        this.map.fitBounds(skipath.getBounds())
      } else {
        for (const i in this.layerComposition.getLayers()) {
          if (this.layerComposition.getLayers()[i].id === id) {
            this.layerComposition.removeLayer(this.layerComposition.getLayers()[i])
          }
        }
      }
    },
    addRemovePoiFromMap: function () {
      if (!this.layerComposition.hasLayer(this.poi)) {
        this.poi.addTo(this.layerComposition)
      } else {
        this.layerComposition.removeLayer(this.poi)
      }
    },
    getLayerInfo: function (id) {
      this.layerProps = this.$store.getters.getLayers.filter(l => l.properties.id === id)[0].properties
      this.drawElevChart()
    },
    toggleModel: function (element, array) {
      if (!array.includes(element))
        array.push(element)
      else
        array.splice(array.indexOf(element), 1)
    },
    addSensorToMap: function (e) {
      const selectedSensor = this.$store.getters.getSensors.filter(sensor => sensor.id === e.srcElement.value)[0]
      const Sensor = new L.marker(selectedSensor.centerCoordinates)
      Sensor.id = selectedSensor.id
      Sensor.bindPopup(selectedSensor.popUpLabel).openPopup()
      if (this.sensorsOn.includes(e.srcElement.value)) {
        Sensor.addTo(this.sensorGroup)
      } else {
        for (const i in this.sensorGroup.getLayers()) {
          if (this.sensorGroup.getLayers()[i].id === selectedSensor.id) {
            this.sensorGroup.removeLayer(this.sensorGroup.getLayers()[i])
          }
        }
      }
    },
    drawElevChart: function () {
      window.AmCharts.makeChart('elevChartdiv', {
        'type': 'serial',
        'theme': 'light',
        'titles': [{
          'text': placeholders.elevChart[this.$i18n.locale].elevChart
        }],
        'marginTop': 30,
        'marginBottom': 30,
        'autoMarginOffset': 20,
        'dataProvider': this.layerProps.elevation,
        'valueAxes': [{
          'position': 'left',
          'axisThickness': 1
        }],
        'graphs': [{
          'id': 'g1',
          'balloonText': "<b><span style='font-size:14px;'>[[value]]</span></b>",
          'bullet': 'round',
          'bulletSize': 1,
          'lineColor': '#d1655d',
          'fillAlphas': 0.4,
          'lineThickness': 2,
          'negativeLineColor': '#637bb6',
          'type': 'line',
          'valueField': 'dH',
          'balloon': {
            'drop': false,
            'adjustBorderColor': false,
            // 'verticalPadding': 1,
            'fillAlpha': 0.1,
            'fillColor': '#FFFFFF',
            // 'horizontalPadding': 1,
            'fontSize': 8,
            'color': '#006CB5',
            'borderColor': '#006CB5'
          }
        }],
        'chartCursor': {
          // 'categoryBalloonDateFormat': 'YYYY',
          'cursorAlpha': 0,
          'valueLineEnabled': false,
          'valueLineBalloonEnabled': false,
          'valueLineAlpha': 0.5,
          'fullWidth': true
        },
        // 'dataDateFormat': 'YYYY',
        'categoryField': 'dist',
        'categoryAxis': {
          // 'minPeriod': 'YYYY',
          // 'parseDates': true,
          'minorGridEnabled': false
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../static/style/leaflet.css";

#map{
  height: 100%;
  width: 100%;
  position: relative;
  z-index: 0;
}
.slimmed {
  width: calc(100% - 400px) !important;
}
.show {
  display: block !important;
}
.hide {
  display: none !important;
}
.container{
  height: 100%;
  width: 100%;
  padding: 0px;
}
.layout{
  height: 100%;
  width: 100%;
}
.list--two-line li:hover {
  background: #0091E1;
}
.list {
  padding-top: 0;
  padding-bottom: 0;
}
.list__tile__action .icon {
  color: #3748AC !important;
}
.list__tile__title{
  color: #3748AC !important;
}
.tileFlake .fa-snowflake-o {
  font-size: 15px;
}
.tileCircle .fa-circle {
  font-size: 15px;
}
.sidebar {
  max-height: none !important;
  overflow-y: auto;
}
#elevChartdiv {
  position: absolute;
  height: 21rem;
  bottom: 0px;
  width: calc(100% - 700px);
  background: #FFFFFF;
  display: none;
}
.details em {
  width: auto;
  color: #000;
  font-weight: 700;
  margin-right: 4px;
  font-style: normal;
}
.sidebarValues {
  position: absolute;
  right: 100px;
}
.infoCard {
  padding: 3px;
}
.infoCard div {
  height: 100%;
  position: relative;
  display: inline-block;
  margin: 0 auto;
}
.infoCard p {
  font-size: 15px;
  margin-bottom: 12px;
}
.infoCard i {
  font-size: 20px;
  text-align: center;
  display: block;
  position: relative;
  top: 10px;
}
.infoIcon {
  margin-right: 5px;
  margin-bottom: 5px;
  cursor: pointer;
  font-size: 20px;
}
.navigation-drawer {
  padding: 0 0 0;
}

</style>



// WEBPACK FOOTER //
// Map.vue?32f59660